import { render, staticRenderFns } from "./BankAccount.html?vue&type=template&id=55256ea5&scoped=true&external"
import script from "./BankAccount.vue?vue&type=script&lang=ts"
export * from "./BankAccount.vue?vue&type=script&lang=ts"
import style0 from "../Account.scss?vue&type=style&index=0&id=55256ea5&prod&lang=scss&scoped=true&external"
import style1 from "./BankAccount.vue?vue&type=style&index=1&id=55256ea5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55256ea5",
  null
  
)

export default component.exports